module.exports = __webpack_public_path__ + "img/logo.4bd38251.png";